const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    performingAction: () =>
        __('Udfører handling …'),
};
